import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardText,
} from 'reactstrap';

import { CardHeaderWithToolbars, Title } from '../../../components/Card/CardHeaderWithToolbars';
import FiltersPanel from '../Filters';
import Toolbars from '../Processed/processedList/filterPanel/Toolbars';
import FilterContainer from '../../../components/Container/FilterContainer/FilterContainer';

import { DEFAULT_SORT_BY, DEFAULT_PER_PAGE } from '../../../constants/settings';
import { getSaleList, disburseSale } from '../../../actions/saleAction';
import privateView from '../../../components/hocs/privateView';
import FailedSaleList from '../Failed/FailedSaleList';
import Analytics from '../../../services/Analytics';

const defaultParams = {
  sort_by: DEFAULT_SORT_BY,
  per_page: DEFAULT_PER_PAGE,
  type: 'need_refund'
};

class NeedRefundSales extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _filterOpen: false,
      _params: {
        ...defaultParams
      }
    };
    this._handleLoadMore = this._handleLoadMore.bind(this);
    this._handleToggleFilterPanel = this._handleToggleFilterPanel.bind(this);
    this._handleRefresh = this._handleRefresh.bind(this);
    this._handleResetFilter = this._handleResetFilter.bind(this);
    this._handleApplyFilter = this._handleApplyFilter.bind(this);
    this._handleCategoryChanged = this._handleCategoryChanged.bind(this);
  }

  componentDidMount() {
    const { email } = this.props.injectedProps;
    this._refreshList();
    Analytics.recordPageView('need_refund_sales', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }

  _getList(rawParams = {}) {
    let p = { ...rawParams };
    if (p.voucher) {
      const { voucher, ...other } = p;
      if (Number(voucher.id)) {
        p = { ...other, voucher_id: voucher.id };
      }
      else {
        p = { ...other, voucher_code: voucher.code };
      }
    }
    if (p.seller && p.seller.id) {
      const { seller, ...other } = p;
      p = { ...other, seller_id: seller.id };
    }
    const params = Object.keys(p)
      .filter(key => p[key] !== '')
      .reduce((obj, current) => ({ ...obj, [current]: p[current] }), {});
    return this.props.getList({ params });
  }

  _refreshList() {
    this._getList(this.state._params);
  }

  _toggleFilterPanel() {
    this.setState({ _filterOpen: !this.state._filterOpen });
  }

  _handleApplyFilter(payloadFilter) {
    this.setState({
      _params: {
        ...this.state._params,
        ...payloadFilter
      }
    }, () => this._getList(this.state._params));
  }

  _handleToggleFilterPanel(e) {
    e.preventDefault();
    this._toggleFilterPanel();
  }

  _handleRefresh(e) {
    e.preventDefault();
    this._refreshList();
  }

  _handleResetFilter(e) {
    e.preventDefault();
    const newState = this.state._filterOpen ? { _filterOpen: !this.state._filterOpen } : {};
    this.setState({
      ...newState,
      _params: { ...defaultParams }
    }, () => this._getList(this.state._params));
  }

  _handleLoadMore(cursor) {
    if (!cursor || this.props.sale.isFetch) return;
    this._getList({ ...this.state._params, cursor });
  }

  async _handleCategoryChanged(category) {
    await this.setState({
      _params: {
        ...this.state._params,
        category: category === '' ? category : category.value,
      },
    });
    const { _params } = this.state;
    this._getList(_params);
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs={12}>
            <Card>
              <CardHeaderWithToolbars>
                <Title>
                  <i className="fa fa-align-justify"></i>
                  <span>Need Refund List</span>
                </Title>
                <Toolbars
                  isOpen={this.state._filterOpen}
                  onToggleFilter={this._handleToggleFilterPanel}
                  onRefreshList={this._handleRefresh}
                  onResetFilter={this._handleResetFilter}
                />
              </CardHeaderWithToolbars>
              <FilterContainer>
                <FiltersPanel
                  {...this.state._params}
                  isOpen={this.state._filterOpen}
                  onApplyFilter={this._handleApplyFilter}
                  isReset={this.state._isResetFilter}
                  onResetFilterCallback={() => this.setState({ _isResetFilter: false, _filterOpen: false })}
                />
              </FilterContainer>
              <CardBody>
                <CardText>
                  In this section all our sales that need refund
                </CardText>
                <FailedSaleList
                  loginId={this.props.injectedProps.id}
                  isLoading={this.props.sale.isFetch}
                  isLoadingMore={this.props.sale.isLoadingMore}
                  listError={this.props.sale.listError}
                  list={this.props.sale.list.data}
                  hasMore={this.props.sale.list.has_more}
                  nextCursor={this.props.sale.list.next_cursor}
                  statusCode={this.props.sale.list.status_code}
                  handleLoadMore={this._handleLoadMore}
                  handleSubmit={(id, payloads) => this.props.disburse(id, payloads)}
                  isSubmit={this.props.sale.isSubmit}
                  dataUpdatedSale={this.props.sale.detail}
                  dataErrorSale={this.props.sale.error}
                  categoryValue={this.state._params.category}
                  onCategoryChanged={this._handleCategoryChanged}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = ({ sale, auth: { id: authId, email, isFetch, isLogged, roles } }) => {
  return {
    sale,
    guardData: { isFetch, isLogged, roles, id: authId, email }
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getList: (query) => dispatch(getSaleList(query)),
    disburse: (id, payload) => dispatch(disburseSale(id, payload))
  };
};

const enhance = connect(mapStateToProps, mapDispatchToProps);
export default enhance(privateView(NeedRefundSales, ['supervisor', 'sale_supervisor']));
